<template>
  <div class="cover" :style="{flexDirection: flipped ? 'row-reverse' : 'row'}">
    <div class="profile-container">
      <div
        class="image"
        :style="{
          backgroundImage: `url(${opponent.image2})`,
          filter: `grayscale(${unlocked ? 0 : 1}) brightness(${unlocked ? 1 : 0.5})`
        }"
      />
      <BaseButtonExpand
        class="button"
        state="open"
        @click.native="$emit('open')"
        v-if="unlocked && round"
      />
      <BaseLockedSymbolCircle
        class="locked-symbol"
        v-if="!unlocked"
      />
      <BaseText3 class="name" :text="opponent.name"/>
    </div>
    <div class="score-container">
      <div>
        <BaseText2 class="label" text="Score"/>
        <BaseText3 class="score" :text="adjustScore(round && round.score || 0)"/>
        <BaseText3 class="outcome" :text="unlocked ? round ? round.userWon ? 'Win' : 'Loss' : 'Unlocked' : 'Locked'"/>
      </div>
      <BaseText2 class="date" v-if="round" :text="formatDate(round.date)"/>
    </div>
  </div>
</template>

<script>
import BaseLockedSymbolCircle from '@/components/BaseLockedSymbolCircle/BaseLockedSymbolCircle'
import BaseButtonExpand from '@/components/BaseButtonExpand/BaseButtonExpand'
import formatDate from '@/utils/formatDate'
import adjustScore from '@/utils/adjustScore'
import BaseText2 from '@/components/BaseText2/BaseText2'
import BaseText3 from '@/components/BaseText3/BaseText3'
export default {
  components: {
    BaseLockedSymbolCircle,
    BaseButtonExpand,
    BaseText2,
    BaseText3
  },
  props: {
    opponent: {
      type: Object,
      required: true
    },
    flipped: {
      type: Boolean,
      required: true
    },
    round: {
      validator: prop => typeof prop === 'object' || prop === null,
      required: true
    },
    unlocked: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    formatDate (date) {
      return formatDate(date)
    },
    adjustScore (score) {
      return adjustScore(score)
    }
  }
}
</script>

<style lang="scss" scoped>
.cover {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
}
.score-container {
  width: 35%;
  height: 100%;
  flex-shrink: 0;
  background: var(--color-white-1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  * { color: var(--color-black-1) };
  padding: var(--spacing-2) 0;
}
.label,
.date {
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
}
.date {
  opacity: 0.5;
}
.score,
.outcome {
  font-size: 1.5rem;
  --letter-spacing: 0;
}
.profile-container {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: var(--spacing-2);
  position: relative;
}
.image {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-size: cover;
  background-position: center center;
  background-color: #1f1e22;
}
.name {
  text-transform: uppercase;
  font-size: 1.5rem;
  text-align: left;
  overflow-wrap: break-word;
  hyphens: auto;
  word-spacing: 10rem;
  z-index: 1;
}
.button,
.locked-symbol {
  position: absolute !important;
  top: 0;
  right: 0;
  margin: var(--spacing-2);
  z-index: 1;
}
</style>
